<template>
  <div class="extra-parameters-bar">
    <div
      v-if="gender && age && !hidePatientDetails"
      class="extra-parameters-bar__item"
    >
      <v-icon
        class="extra-parameters-bar__icon"
        color="rgba(0, 0, 0, 0.87)"
      >mdi-human-{{ gender }}</v-icon>
      {{ $ucfirst($t(gender)) }}, {{ age }} {{ $t('years') }}
    </div>
    <div
      v-if="heartRate"
      class="extra-parameters-bar__item"
    >
      <v-icon
        class="extra-parameters-bar__icon"
        color="rgba(0, 0, 0, 0.87)"
      >mdi-heart-pulse</v-icon>
      {{ heartRate }} {{$t('units.bpm', {catalog: 'app_mobile'})}}
    </div>
    <div
      v-if="distanceWalked"
      class="extra-parameters-bar__item"
    >
      <v-icon
        class="extra-parameters-bar__icon"
        color="rgba(0, 0, 0, 0.87)"
      >mdi-walk</v-icon>
      {{ distanceWalked }} m
    </div>
  </div>
</template>

<script>

/**
 * Component ExtraParametersBar.vue
 *
 * @module ExtraParametersBar
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.9] app/src/APP_DASHBOARD/templates/components/Parts/ExtraParametersBar.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'ExtraParametersBar',
  props: {
    hidePatientDetails: {
      type: Boolean,
      default: () => false,
    },
    gender: {
      type: String,
      required: false,
    },
    age: {
      type: [String, Number],
      required: false,
    },
    heartRate: {
      type: [String, Number],
      required: false,
    },
    distanceWalked: {
      type: [String, Number],
      required: false,
    },
  },
};
</script>

<style lang="scss">
.extra-parameters-bar {
  padding: 12px 24px 12px 30px;
  border-bottom: 1px solid #d6dbe4;
  margin-left: -12px;
  margin-right: -12px;
}

.extra-parameters-bar__item {
  display: inline-flex;
  margin-right: 30px;
  justify-content: center;
  align-items: center;
  color: rgba(0, 0, 0, 0.84);
  font-weight: 600;
}

.extra-parameters-bar__icon {
  max-height: 24px;
  margin-right: 10px;
}
</style>
